<template>
    <v-card>
        <v-card-title>
            Projects List
            <v-spacer></v-spacer>
            <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>

        <v-data-table :headers="headers"
                      :items="items"
                      :search="search"
                      :pagination.sync="pagination"
                      :total-items="pagination.totalItems">
            <template slot="items" scope="props">
                <td class="text-xs-right">{{ props.item.name }}</td>
                <td class="text-xs-right">{{ props.item.client.name }}</td>
                <td class="text-xs-right">
                    <v-icon v-if="props.item.is_billable" color="grey">trending_up</v-icon>
                    <v-icon v-if="!props.item.is_billable" color="grey">trending_flat</v-icon>
                </td>
                <td class="text-xs-right">
                    <v-icon v-if="props.item.is_active" color="grey">thumb_up</v-icon>
                    <v-icon v-if="!props.item.is_active" color="grey">thumb_down</v-icon>
                </td>
                <td class="text-xs-right">{{ props.item.created }}</td>
            </template>

            <template slot="pageText" scope="{ pageStart, pageStop }">
                From {{ pageStart }} to {{ pageStop }}
            </template>
        </v-data-table>
    </v-card>
</template>


<script>
    import moment from 'moment';
    import _ from 'lodash';
    export default {
        props: ['data'],
        data() {
            return {
                max25chars: (v) => v.length <= 25 || 'Input too long!',
                tmp: '',
                search: '',
                pagination: {
                    rowsPerPage: 10
                },
                headers: [{
                    text: 'Name',
                    align: 'left'
                },
                    {
                        text: 'Client',
                        align: 'left',
                        value: 'client.name'
                    },
                    {
                        text: 'Is Billable',
                        value: 'is_billable'
                    },
                    {
                        text: 'Is Active',
                        value: 'is_active'
                    },
                    {
                        text: 'Created',
                        value: 'created'
                    }
                ],
                items: []
            }
        },
        watch: {
            data: function (newValue) {
                this.items = newValue.projects;
                this.pagination = {
                    page: newValue.page,
                    rowsPerPage: newValue.per_page,
                    totalItems: newValue.total_entries
                }
                this.items = _.map(this.items, (item) => {
                    item.created = moment(item.created_at).format('L');
                    item.roles_view = _.join(item.roles, ', ');
                    return item
                })
            },
            pagination: function (newValue, oldValue) {
                if (!oldValue || (oldValue.page == newValue.page &&
                    oldValue.rowsPerPage == newValue.rowsPerPage))
                    return;
                this.$emit('change', {
                    page: newValue.page,
                    per_page: newValue.rowsPerPage
                });
            }
        },
        created() {
            this.items = this.data.projects;
            this.items = _.map(this.items, (item) => {
                item.created = moment(item.created_at).format('L');
                item.roles_view = _.join(item.roles, ', ');
                item.weekly_capacity_view = (item.weekly_capacity / (60 * 60)).toFixed(2);
                return item
            });
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Admin/Projects/ProjectsTable.vue